import palette from '../../../../theme/palette';
import { handlePriceDisplayUnit, handlePriceDisplay } from 'common/utils';
import { DashboardKpiTypes } from 'reducers';

export const options = (langDashboard, districtHkiOptions, districtNtOptions, districtKltOptions, relativeRegionHkiTotal, relativeRegionKlnTotal, relativeRegionNtTotal, lang, locale) => ({

  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  legend: { 
    display: true,
    position: 'top',
    align: 'end',
    labels:{fontSize: 10} 
  },
  cornerRadius: 20,
  tooltips: {
    enabled: true,
    mode: 'index',
    intersect: false,
    borderWidth: 1,
    borderColor: palette.divider,
    backgroundColor: palette.white,
    titleFontColor: palette.text.primary,
    bodyFontColor: palette.text.secondary,
    footerFontColor: palette.text.secondary,
    displayColors: false, 
    callbacks: {
      afterBody: function (tooltipItem, data) {
          if (Object.values(districtHkiOptions).includes(tooltipItem[0].label)) {
            return langDashboard.tooltipdistrictHkiTotal + relativeRegionHkiTotal[DashboardKpiTypes.NEW_CLIENT_UPDATES - 1];
          } else if (Object.values(districtKltOptions).includes(tooltipItem[0].label)) {
            return langDashboard.tooltipdistrictKlnTotal + relativeRegionKlnTotal[DashboardKpiTypes.NEW_CLIENT_UPDATES - 1];
          } else if (Object.values(districtNtOptions).includes(tooltipItem[0].label)) {
            return langDashboard.tooltipDistrictNtTotal + relativeRegionNtTotal[DashboardKpiTypes.NEW_CLIENT_UPDATES - 1];
          }
      },
      label: function (tooltipItem, data) {
          var labelName = data.datasets[tooltipItem.datasetIndex].label;
          switch (labelName) {
            case langDashboard.own:
              return langDashboard.tooltipOwnTotal + tooltipItem.value;
            case langDashboard.labelDistrict:
              return tooltipItem.label + langDashboard.total + tooltipItem.value;
            case langDashboard.districtHki:
              if (Object.values(districtHkiOptions).includes(tooltipItem.label)) {
                return tooltipItem.label + langDashboard.total + tooltipItem.value;
              }
              break;
            case langDashboard.districtKln:
              if (Object.values(districtKltOptions).includes(tooltipItem.label)) {
                return tooltipItem.label + langDashboard.total + tooltipItem.value;
              }
              break;
            case langDashboard.districtNt:
              if (Object.values(districtNtOptions).includes(tooltipItem.label)) {
                return tooltipItem.label + langDashboard.total + tooltipItem.value;
              }
              break;
          }
        } 
      
    }

  },
  layout: { padding: 0 },
  scales: {
    xAxes: [
      {
        // barThickness: 12,
        // maxBarThickness: 10,
        // barPercentage: 0.5,
        // categoryPercentage: 0.5,
        // stacked: true,
        ticks: {
          fontColor: palette.text.secondary,
          beginAtZero: true,
          precision:0,
          min: 0,
          callback: function (value) {
            return value >= 1000000 ? handlePriceDisplay(value, locale) + handlePriceDisplayUnit(value, locale, lang) : value;
          }
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: palette.divider
        },
        scaleLabel: {
          display: true,
          labelString: langDashboard.numberOfClientUpdates,
        }
      }
    ],
    yAxes: [
      {
        stacked: true,
        ticks: {
          fontColor: palette.text.secondary,
          // beginAtZero: true,
          // min: 0
        },
        gridLines: {
          display: false,
          drawBorder: false
        },
        scaleLabel: {
          display: true,
          labelString: langDashboard.district,
          // padding: {top : 0,
          //           bottom: 100},
          

        },
        
      }
    ]
  }
}
);
